class MatchFinalizeController {
	constructor(MatchesFactory, $rootScope, $filter, ngDialog){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		/* Load Matches dat */
		vm.$onInit = function(){
			vm.rootScope = $rootScope;
			vm.options = [
				{id: 1, name: 'FINALIZE_ROUND_ONE', actionId: MatchesFactory.MATCH_STATES.MATCH_STATE_ROUND_ONE},
				{id: 2, name: 'FINALIZE_ROUND_TWO', actionId: MatchesFactory.MATCH_STATES.MATCH_STATE_ROUND_TWO},
				{id: 3, name: 'FINALIZE_MATCH', actionId: MatchesFactory.MATCH_STATES.MATCH_STATE_END},
			];
		};

		vm.updateMatchGridOptions = {
			enableSorting: false,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: false,
			columnDefs: [
				{
					field: 'targetName',
					enableFiltering: false,
					name: $translate('TARGET_NAME'),
				}, {
					field: 'playerName',
					enableFiltering: false,
					name: $translate('PLAYER_NAME'),
				}, {
					field: 'teamName',
					enableFiltering: false,
					name: $translate('TEAM_NAME'),
				},
			],
		};

		vm.finalize = (state) =>{
			MatchesFactory.finalize(vm.rootScope.currentMatchId, state)
						  .then(response =>{
							  ngDialog.open({template: 'successTemplate'});
							  vm.updateMatchGridOptions.data = response.data;
						  });
		};
	}
}

export default MatchFinalizeController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchFinalize/matchFinalize.controller.js